import { FC, useEffect, useRef, useState } from 'react';
// import { getIsLogin } from 'lowcode/utils/getIsLogin';
import Banner from '../Common/Banner';
import Refer, { ReferHandle } from '../Common/Referral';
import Terms from '../Common/Terms';
import Subscribe from '../Common/Subscribe';
import { PlanType } from '../index.d';
import MyBonus from './MyBonus';
import RankingList from './RankingList';
import HowWorks from './HowWorks';
import Faq from './FAQ';
import styled from './index.module.scss';
import RewardsModal, { RewardsModalHandle } from './RewardsModal';
import UserStories from './UserStories';
import SpecialReward from './SpecialReward';
import { useReferralDispatch, useReferralStore } from '@/components/Ambassador/ReferralProvider';
import { useGlobal } from '@/utils/useGlobal';
import Button from '@/components/UI/Button';
import EfModal from '@/components/UI/Modal';
import efBridge from '@/utils/JSBridge';
import getLocal from '@/app/utils/getLocal';

const ShareCompoment: FC<{ isLogin: boolean }> = ({ isLogin }) => {
    const { useLang, useRouter, isApp } = useGlobal();
    const router = useRouter();
    const { locale, pathname } = getLocal();
    const { t } = useLang('referral');
    const [show, setShow] = useState(false);
    const referRef = useRef<ReferHandle>(null);
    const rewardsRef = useRef<RewardsModalHandle>(null);
    const dispatch = useReferralDispatch();
    const { referralInfo, inBlackList } = useReferralStore();
    // const isLogin = getIsLogin();
    const path = `/${locale}${pathname}`;
    // const path = `/${locale}/referral`;

    useEffect(() => {
        dispatch({ type: 'getReferralInfo', payload: { locale, path } });
    }, []);

    useEffect(() => {
        const { pop } = router.query;
        if (!referralInfo) return;
        if (!referralInfo.planId) {
            // 判断是否为app环境
            if (isApp) {
                setShow(true);
            } else {
                router.push(`/${locale}/ecocredits`);
            }
        }
        if (pop === 'rewards' && rewardsRef && !inBlackList) rewardsRef.current?.show();
        if (pop === 'share' && referRef && !inBlackList) referRef.current?.show();
        history.pushState('', '', location.href.replace(`?pop=${pop}`, ''));
    }, [referRef, referralInfo]);

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2102;
                    }
                    .ant-modal-content {
                        border-radius: 12px !important;
                    }
                `}
            </style>
            <div className={`${styled.share_compoment}`}>
                <Banner subtitle={referralInfo?.label || ''} title={referralInfo?.title || ''} desc={referralInfo?.subTitle || ''}>
                    <Button className="refer-btn" onClick={() => referRef.current?.show()} loading={!referralInfo} disabled={inBlackList}>
                        {isLogin ? t('banner.btn3') : t('banner.btn1')}
                    </Button>
                    {/* <Button className="refer-btn white" onClick={handleRewardsPop}>
                        {t('banner.btn2')}
                    </Button> */}
                </Banner>
                {isLogin && <MyBonus />}
                <HowWorks onRefer={() => referRef.current?.show()} isLogin={isLogin} />
                <Refer ref={referRef} />
                {/* <RankingList /> */}
                <UserStories isLogin={isLogin} handleShare={() => referRef.current?.show()} />
                <SpecialReward />
                <Faq />
                <Terms />
                {/* <Subscribe isShare={true} /> */}
                {isLogin && <RewardsModal ref={rewardsRef} planId={referralInfo?.planId} />}
                <EfModal
                    width="560"
                    visible={show}
                    open={show}
                    className={`${styled.no_active_modal}`}
                    centered={true}
                    getContainer={true}
                    onCancel={() => setShow(false)}
                >
                    <div className="content">
                        <p className="msg">{t('activity_site_not_supported')}</p>
                        <Button className="btn" onClick={() => efBridge?.callHandler('closeWebView')}>
                            {t('button_ok')}
                        </Button>
                    </div>
                </EfModal>
            </div>
        </>
    );
};

export default ShareCompoment;
